import { render, staticRenderFns } from "./PazienteTeleconsultoEdit.vue?vue&type=template&id=880f5000"
import script from "./PazienteTeleconsultoEdit.vue?vue&type=script&lang=js"
export * from "./PazienteTeleconsultoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports